<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      width="450"
    >
      <v-sheet>
        <v-container>
          <v-subheader>Ticket Nuevo</v-subheader>
          <cuentas-select
            v-if="defaultable"
            tabindex="1"
          ></cuentas-select>
          <cuentas-selected
            v-else
            tabindex="1"
          ></cuentas-selected>
          <date-input
            v-model="fecha"
            label="Fecha"
            max-today
            tabindex="2"
          ></date-input>
          <v-row no-gutters>
            <v-col cols="6">
              <v-text-field
                :value="periodo | moment('MMMM/YYYY')"
                readonly
                dense
                prepend-icon="mdi-calendar"
                color="primary"
                tabindex="-1"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="precio | formatToTwoDecimals"
                readonly
                dense
                prepend-icon="mdi-currency-usd"
                color="primary"
                tabindex="-1"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-2"></v-divider>
          <productos-select
            v-model="productoId"
            @coeficiente="onCoeficiente"
            tabindex="3"
          ></productos-select>
          <v-row
            no-gutters
            v-if="coeficiente === 1"
          >
            <v-col cols="6">
              <v-text-field
                v-model="litros"
                :disabled="!(precioId > 0)"
                label="Litros"
                prepend-icon="mdi-water"
                color="primary"
                type="number"
                @keydown.enter="onSubmit"
                @input="handleInputLitros"
                tabindex="4"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="cantidad"
                :disabled="!(precioId > 0)"
                label="Kilos"
                prepend-icon="mdi-weight-kilogram"
                color="primary"
                type="number"
                :rules="rules.cantidad"
                @keydown.enter="onSubmit"
                @input="handleInputKilos"
                tabindex="5"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            v-else
          >
            <v-col cols="12">
              <v-text-field
                v-model="cantidadCoeficiente"
                :disabled="!(precioId > 0)"
                label="Cantidad"
                prepend-icon="mdi-weight-kilogram"
                color="primary"
                type="number"
                :rules="rules.cantidad"
                @keydown.enter="onSubmit"
                @input="handleInputCantidadCoeficiente"
                tabindex="4"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-footer>
            <v-btn
              :disabled="!updatable && $can('debitos.store')"
              color="primary"
              @click="onSubmit"
              :loading="loading"
              block
              tabindex="6"
            >
              Registrar
            </v-btn>
          </v-footer>
        </v-container>
      </v-sheet>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import CuentasSelect from '@/pages/cuentas/SelectComponent'
import CuentasSelected from '@/pages/cuentas/SelectedComponent'
import PrecioMixin from '@/mixins/Precios';
import PeriodoMixin from '@/mixins/Periodo';
import PeriodoSelect from '@/components/PeriodoSelect'
import MonthPicker from '@/components/MonthPicker'
import DateInput from '@/components/DateInput'
import ProductoSelect from '@/pages/productos/SelectComponent'
import KilosInput from '@/components/KilosInput'
import PreciosVigentesSelected from '@/pages/precios_vigentes/SelectedComponent'
export default {
  name: 'TicketsCreateComponent',
  mixins: [PeriodoMixin, PrecioMixin],
  components: {
    'cuentas-select': CuentasSelect,
    'cuentas-selected': CuentasSelected,
    'periodo-select': PeriodoSelect,
    'date-input': DateInput,
    'month-picker': MonthPicker,
    'productos-select': ProductoSelect,
    'kilos-input' : KilosInput,
    'precios-vigentes-selected': PreciosVigentesSelected
  },
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    selected: Boolean,
  },
  data () {
    return {
      drawer: true,
      valid: false,
      focusGas: false,
      kilogramos: null,
      hoy: null,
      litros: 0,// Densidad = masa / volumen,
      precio: 0,
      coeficiente: 1,
      cantidadCoeficiente: 0,
    }
  },
  beforeDestroy () {
    // Remueve el event listener en el gancho beforeDestroy
    window.removeEventListener('keydown', this.handleKeyboard);
    this.$root.$off('update:appbarnav', this.onUpdateAppNavBar);
    this.onLimpiar()
  },
  created () {
    this.hoy = this.$moment().format('YYYY-MM-DD')
    this.$root.$on('update:appbarnav', this.onUpdateAppNavBar);
    this.onLimpiar()
  },
  computed: {
    ...mapGetters('Cuentas', ['selectedId', 'defaultable']),
    ...mapGetters('Debitos', ['edited', 'rules', 'loading', 'updatable']),
    fecha: {
      get () {
        return this.edited.fecha
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          fecha: value
        })
      }
    },
    periodo: {
      get () {
        return this.edited.periodo
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          periodo: value
        })
      }
    },
    cantidad: {
      get () {
        return this.edited.cantidad
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          cantidad: value
        })
      }
    },
    importe: {
      get () {
        return this.edited.importe
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          importe: value
        })
      }
    },
    precioId: {
      get () {
        return this.edited.precio_id
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          precio_id: value
        })
      }
    },
    productoId: {
      get () {
        return this.edited.producto_id
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          producto_id: value
        })
      }
    },
    cuentaId: {
      get () {
        return this.edited.cuenta_id
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          cuenta_id: value
        })
      }
    },
  },
  watch: {
    async fecha (newValue) {
      if (newValue) {
        this.periodo = await this.periodoFechaTo(newValue);
        const precio = await this.precioByVigencia(newValue);
        if(precio && precio.id > 0) {
          this.precioId = precio.id;
          this.precio = precio.pleno;
        }
      } else {
        this.precio = 0;
        this.periodo = null;
        this.precioId = null;
      }
    },
    cantidad (newVal) {
      this.importe = this.precio * newVal
    },
    selectedId (newVal) {
      this.cuentaId = newVal
    },
  },
  methods: {
    // ...mapActions('Transacciones', ['onFetch']),
    ...mapActions('Debitos', ['onSave', 'onClearEdited', 'onClearSelected']),
    ...mapMutations('Debitos', ['setEdited']),
    async onLimpiar () {
      this.onClearEdited()
      this.onClearSelected()
      this.$store.dispatch('Cuentas/onClearEdited');
      this.$store.dispatch('Cuentas/onClearSelected');
      this.productoId = 1;
      this.fecha = await this.$moment().format('YYYY-MM-DD');
      this.litros = 0;
    },
    handleInputKilos() {
      this.convertirKilosALitros()
    },
    handleInputLitros() {
      this.convertirLitrosAKilos()
    },
    handleInputCantidadCoeficiente(newVal) {
      const cantidad = parseFloat(newVal);
      if (cantidad > 0) {
        this.cantidadCoeficiente = cantidad;
        this.cantidad = cantidad * this.coeficiente;
        this.importe = this.cantidad * this.precio;
      }
    },
    onSubmit(event) {
      event.preventDefault();
      // Si ya estamos enviando, salimos de la función
      if (this.isSubmitting || !this.fecha) {
        return;
      }
      this.isSubmitting = true; // Establecer la bandera en true

      this.onSave().then(response => {
        this.$store.dispatch('Tickets/onFetch');
        this.onLimpiar();
      })
      .finally(() => {
        this.isSubmitting = false; // Restablecer la bandera a false al finalizar
      });
    },
    handleKeyboard(event) {
      if(event.key === 'Enter' && !event.ctrlKey) {
        this.onSubmit(event)
      }
      else if(event.altKey && event.key == 'k') {
        event.preventDefault()
        this.focusGas = true
      }
    },
    onUpdateAppNavBar() {
      this.drawer = !this.drawer
    },
    convertirKilosALitros() {
      const cantidad = parseFloat(this.cantidad);
      if (cantidad > 0) {
        this.litros = parseFloat((cantidad / 0.51));
      }
    },
    convertirLitrosAKilos() {
      const litros = parseFloat(this.litros);
      if (litros > 0) {
        this.cantidad = parseFloat((litros * 0.51));
      }
    },
    onCoeficiente(newVal) {
      this.coeficiente = parseInt(newVal)
      this.importe = this.cantidad * this.precio;
    }
  },
}
</script>
